var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoticeLogo = function SvgNoticeLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44.121,
    height: 44.121,
    fill: "#827127",
    rx: 4.644
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.171 22.567c6.749 0 7.178-4.445 7.178-6.068s-.43-6.049-7.178-6.049h-3.66v22.214h-1.547V10.45l-5.571 1.59.289.97 2.442-.698v20.35h-3.352v1.01h12.126v-1.01h-3.354V22.566h2.627zm-.564-11.107c3.871 0 4.387 3.51 4.387 5.04s-.516 5.057-4.387 5.057h-2.063V11.46z"
  })));
};
export default SvgNoticeLogo;